// Data backgrounds functionality
export function dataBackgrounds() {
  document.querySelectorAll('.custom-headline[data-hmode="cover-image"]').forEach((div) => {
    if ('' !== div.getAttribute('data-bgimage')) {
      const img = div.getAttribute('data-bgimage');
      div.style.backgroundImage = 'url(' + img + ')';
    }
  });
}
